<template>
  <div v-if="dataPreReady" class="pdf-container">
    <div v-if="dataReady" id="dataReady" />
    <div id="pdf-page-1" class="pdf-page">
      <div class="logo">
        <div class="d-flex justify-content-center">
          <img
              :src="
                '/static/images/unpd/unpd_logo_white_' + lang + '.svg'
              "
              height="200"
              style="margin: 0px -45px 0 0"
          />
          <img
            :src="'./static/images/GES_Logo-White.svg'"
            height="260"
            style="margin-top: -30px;"
          />
        </div>
      </div>
      <div class="info-company">
        <b-row>
          <b-col>
            <h3
              v-if="getBusiness.selfAssessment_general_business_companyName"
              id="companyName"
            >
              {{getBusiness.selfAssessment_general_business_companyName }}
            </h3>
            <h4>{{ $t("label_reports_genderGap_title") }}</h4>
            <h4>{{ $t("label_reports_genderGap_subtitle") }}</h4>
            <h4>{{ $t("label_reports_date_caption") }} {{ today }}</h4>
          </b-col>
        </b-row>
      </div>
    </div>
    <div id="pdf-page-2" class="pdf-page pdf-page-flex resume">
      <div class="page-number">
        {{ pages["0treemap"] }}
      </div>
      <div class="sidebar">
        <div class="top">
          <b-img
            v-if="lang != 'labels'"
            center
            :src="'../static/images/GES_Logo-White' + '.svg'"
            height="100"
          />
          <h3>{{ $t("label_reports_genderGap_title") }}</h3>
        </div>
        <div class="middle">
          <h2>
            {{ $t("label_reports_genderGap_generalSummary_lettlerhead_title") }}
          </h2>
        </div>
        <div class="bottom">
          <b-img
            v-if="lang != 'labels'"
            center
            :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
            height="150"
          />
        </div>
      </div>
      <div class="content-sumary">
        <div class="conventions">
          <div class="general-index-container">
            <card-general-index height="170px" />
          </div>
          <div class="conventions-container">
            <card-conventions height="170px" />
          </div>
        </div>
        <div class="chart">
          <card-chart-treemap
            alias="treemap"
            height="480px"
            :back-buttom="false"
          />
          <p class="conventions-disclaimer">
            * {{ $t("label_reports_genderGap_note") }}
          </p>
        </div>
      </div>
    </div>
    <template v-for="(pillar, index) in pillarsIds">
      <div
        :id="'pdf-page-' + pages[index + '0']"
        :key="index"
        class="pdf-page pdf-page-flex pillar-page"
      >
        <div class="page-number">
          {{ pages[index + "0"] }}
        </div>
        <div class="sidebar" :class="index % 2 == 1 ? 'second-color' : ''">
          <div class="top">
            <b-img
              v-if="lang != 'labels'"
              center
              :src="'../static/images/GES_Logo-White' + '.svg'"
              height="100"
            />
            <h3>{{ $t("label_reports_genderGap_title") }}</h3>
          </div>
          <div class="middle">
            <b-img
              center
              :src="'/static/icons/Home/' + pillar + '_icon.svg'"
              width="100"
            />
            <h2>
              {{
                $t("label_reports_genderGap_generalSummary_lettlerhead_title")
              }}
            </h2>
            <h2>{{ $t("label_indicator_pillar_" + pillar + "_name") }}</h2>
          </div>
          <div class="bottom">
            <b-img
              v-if="lang != 'labels'"
              center
              :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
              height="150"
            />
          </div>
        </div>
        <div class="content">
          <div class="radar">
            <card-pillar-info
              :pillar-id="pillar"
              height="765px"
              :vertical-center="true"
            />
          </div>
          <div class="resume">
            <card-chart-radar
              :pillar-id="pillar"
              alias="pdf-report-radar"
              height="765px"
              :vertical-center="true"
            />
          </div>
        </div>
      </div>
      <!-- multipleIndicators summary per sections support -->
      <div v-if="multipleIndicatorsPage(pillar)" :key="index">
        <template
          v-for="(paging, indexIndicatorSummary) in indicatorSummarySections[
            pillar
          ].pages"
        >
          <div
            :id="
              'pdf-page-' +
              getPartialPillarSummaryPage(index, indexIndicatorSummary)
            "
            :key="indexIndicatorSummary"
            class="pdf-page pdf-page-flex pillar-page"
          >
            <div class="page-number">
              {{ getPartialPillarSummaryPage(index, indexIndicatorSummary) }}
            </div>
            <div class="sidebar" :class="index % 2 == 1 ? 'second-color' : ''">
              <div class="top">
                <b-img
                  v-if="lang != 'labels'"
                  center
                  :src="'../static/images/GES_Logo-White' + '.svg'"
                  height="100"
                />
                <h3>{{ $t("label_reports_genderGap_title") }}</h3>
              </div>
              <div class="middle">
                <b-img
                  center
                  :src="'/static/icons/Home/' + pillar + '_icon.svg'"
                  width="100"
                />
                <h2>
                  {{
                    $t(
                      "label_reports_genderGap_generalSummary_lettlerhead_title"
                    )
                  }}
                </h2>
                <h2>{{ $t("label_indicator_pillar_" + pillar + "_name") }}</h2>
              </div>
              <div class="bottom">
                <b-img
                  v-if="lang != 'labels'"
                  center
                  :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
                  height="150"
                />
              </div>
            </div>
            <div class="content">
              <card-chart-pillar-summary
                :pillar-id="pillar"
                :section-to-display="paging"
                alias="pdf-report-resume"
                style="width: 100%"
                :compact="true"
              />
            </div>
          </div>
        </template>
      </div>
      <div v-if="!multipleIndicatorsPage(pillar)" :key="index">
        <div
          :id="'pdf-page-' + pages[index + '1' + 'gauge']"
          class="pdf-page pdf-page-flex pillar-page"
        >
          <div class="page-number">
            {{ pages[index + "1" + "gauge"] }}
          </div>
          <div class="sidebar" :class="index % 2 == 1 ? 'second-color' : ''">
            <div class="top">
              <b-img
                v-if="lang != 'labels'"
                center
                :src="'../static/images/GES_Logo-White' + '.svg'"
                height="100"
              />
              <h3>{{ $t("label_reports_genderGap_title") }}</h3>
            </div>
            <div class="middle">
              <b-img
                center
                :src="'/static/icons/Home/' + pillar + '_icon.svg'"
                width="100"
              />
              <h2>
                {{
                  $t("label_reports_genderGap_generalSummary_lettlerhead_title")
                }}
              </h2>
              <h2>{{ $t("label_indicator_pillar_" + pillar + "_name") }}</h2>
            </div>
            <div class="bottom">
              <b-img
                v-if="lang != 'labels'"
                center
                :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
                height="150"
              />
            </div>
          </div>
          <div class="content">
            <card-chart-pillar-summary
              :pillar-id="pillar"
              alias="pdf-report-resume"
              style="width: 100%"
              :compact="true"
            />
          </div>
        </div>
      </div>
      <!-- end of summary per section support -->
      <template
        v-for="(indicator, indexIndicator) in indicatorPerPillar(pillar)"
      >
        <div
          :id="'pdf-page-' + pages[index + '' + (indexIndicator + 1)]"
          :key="indexIndicator"
          class="pdf-page pdf-page-flex pillar-page indicator-page"
        >
          <div class="page-number">
            {{ pages[index + "" + (indexIndicator + 1)] }}
          </div>
          <div class="sidebar" :class="index % 2 == 1 ? 'second-color' : ''">
            <div class="top">
              <b-img
                v-if="lang != 'labels'"
                center
                :src="'../static/images/GES_Logo-White' + '.svg'"
                height="100"
              />
              <h3>{{ $t("label_reports_genderGap_title") }}</h3>
            </div>
            <div class="middle">
              <b-img
                center
                :src="'/static/icons/Home/' + pillar + '_icon.svg'"
                width="100"
              />
              <h2>
                {{
                  $t(
                    "label_reports_genderGap_pillarIndicator_lettlerhead_title"
                  )
                }}
              </h2>
              <h2>{{ $t("label_indicator_pillar_" + pillar + "_name") }}</h2>
              <div class="indicator-label">
                <p>
                  {{ $t("label_indicator_" + pillar + indicator + "_acronym") }}
                </p>
              </div>
            </div>
            <div class="bottom">
              <b-img
                v-if="lang != 'labels'"
                center
                :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
                height="150"
              />
            </div>
          </div>

          <div class="content-indicator">
            <div class="block">
              <div class="content-card">
                <card-indicator-info-gender-gap
                  :pillar-id="pillar"
                  :indicator-id="pillar + indicator"
                  height="100%"
                />
              </div>
              <div class="content-card">
                <card-chart-gauge
                  :pillar-id="pillar"
                  :indicator-id="pillar + indicator"
                  :alias="'gauge-pdf' + pillar + indicator"
                  height="100%"
                />
              </div>
              <!--<div class="conventions-2">
                <card-conventions height="235px"></card-conventions>
              </div>-->
            </div>
            <!--            <div class="block" v-if="comment[pillar+indicator]">
              <b-card style="    width: 100%;    margin-right: 10px;">
                <h4 class="card-title">{{$t('label_reports_genderGap_comments')}}</h4>
                <div v-for="comm in comment[pillar+indicator]">{{comm.comment}}</div>

              </b-card>
            </div>-->
            <div
              v-if="
                !hasMoreThanOneChart(pillar, indicator) &&
                !isFullPageIndicatorGraph(pillar, indicator)
              "
              class="block"
            >
              <div class="content-card-double">
                <card-charts-indicator
                  :pillar-id="pillar"
                  :indicator-id="pillar + indicator"
                  :alias="'chart' + pillar + indicator"
                  height="335px"
                  :max-charts="1"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- multiple Indicator Graphs -->
        <template
          v-if="
            getIndicatorPagingInfo(pillar, indicator) &&
            (isFullPageIndicatorGraph(pillar, indicator) ||
              hasMoreThanOneChart(pillar, indicator))
          "
        >
          <template
            v-for="(paging, chart) in multipleGraphSections[pillar + indicator]
              .pages"
          >
            <div
              :id="
                'pdf-page-' +
                getMultipleGraphsPage(index, indexIndicator, chart)
              "
              :key="chart"
              class="pdf-page pdf-page-flex pillar-page indicator-page"
            >
              <div class="page-number">
                {{ getMultipleGraphsPage(index, indexIndicator, chart) }}
              </div>
              <div
                class="sidebar"
                :class="index % 2 == 1 ? 'second-color' : ''"
              >
                <div class="top">
                  <b-img
                    v-if="lang != 'labels'"
                    center
                    :src="'../static/images/GES_Logo-White' + '.svg'"
                    height="100"
                  />
                  <h3>{{ $t("label_reports_genderGap_title") }}</h3>
                </div>
                <div class="middle">
                  <b-img
                    center
                    :src="'/static/icons/Home/' + pillar + '_icon.svg'"
                    width="100"
                  />
                  <h2>
                    {{
                      $t(
                        "label_reports_genderGap_pillarIndicator_lettlerhead_title"
                      )
                    }}
                  </h2>
                  <h2>
                    {{ $t("label_indicator_pillar_" + pillar + "_name") }}
                  </h2>
                  <div class="indicator-label">
                    <p>
                      {{
                        $t("label_indicator_" + pillar + indicator + "_acronym")
                      }}
                    </p>
                  </div>
                </div>
                <div class="bottom">
                  <b-img
                    v-if="lang != 'labels'"
                    center
                    :src="
                      '/static/images/unpd/unpd_logo_white_' + lang + '.svg'
                    "
                    height="150"
                  />
                </div>
              </div>
              <div class="content-indicator">
                <div class="block">
                  <div class="content-card-double">
                    <b-row>
                      <b-col>
                        <card-charts-indicator
                          :first-chart="paging.firstChart"
                          :single-chart="false"
                          :pillar-id="pillar"
                          :indicator-id="pillar + indicator"
                          :alias="'chart' + pillar + indicator"
                          height="335px"
                          :max-charts="paging.numberOfCharts"
                        />
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
        <!-- end of multiple Indicator Graphs -->
      </template>
      <template v-if="indicatorsHasComments[pillar]">
        <template v-if="comment[pillar + '_indicators_comment_all']">
          <div
            v-for="(commentPage, commentPageIndex) in comment[
              pillar + '_indicators_comment_all'
            ]"
            :id="'pdf-page-comments1-' + (200 + index)"
            :key="commentPageIndex"
            class="pdf-page pdf-page-flex pillar-page indicator-page"
          >
            <!--<div class="page-number">{{ pages[index + '0'] }}</div>-->
            <div class="sidebar">
              <div class="top">
                <b-img
                  v-if="lang != 'labels'"
                  center
                  :src="'../static/images/GES_Logo-White' + '.svg'"
                  height="100"
                />
                <h3>{{ $t("label_reports_genderGap_title") }}</h3>
              </div>
              <div class="middle">
                <b-img
                  center
                  :src="'/static/icons/Home/' + pillar + '_icon.svg'"
                  width="100"
                />
                <h2>{{ $t("label_reports_genderGap_comments_short") }}</h2>
                <h2>{{ $t("label_indicator_pillar_" + pillar + "_name") }}</h2>
              </div>
              <div class="bottom">
                <b-img
                  v-if="lang != 'labels'"
                  center
                  :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
                  height="150"
                />
              </div>
            </div>
            <div class="content">
              <b-card style="width: 100%">
                <h4
                  style="
                    margin-top: 30px;
                    margin-bottom: 50px;
                    margin-left: 20px;
                  "
                >
                  {{ $t("label_reports_genderGap_comments_short") }}
                </h4>
                <div>
                  <div style="padding: 20px">
                    <div style="white-space: pre-wrap">
                      {{ commentPage }}
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </template>
      </template>
    </template>

    <template v-if="comment['general']">
      <div
        v-for="(commentPage, indexPage) in comment['general']"
        :id="'pdf-general-comments-' + indexPage"
        :key="indexPage"
        class="pdf-page pdf-page-flex pillar-page"
      >
        <!--<div class="page-number">{{ pages[index + '0'] }}</div>-->
        <div class="sidebar">
          <div class="top">
            <b-img
              v-if="lang != 'labels'"
              center
              :src="'../static/images/GES_Logo-White' + '.svg'"
              height="100"
            />
            <h3>{{ $t("label_reports_genderGap_title") }}</h3>
          </div>
          <div class="middle">
            <!--<b-img center :src="'/static/icons/Home/'+pillar+'_icon.svg'" width="100" />-->
            <h2>{{ $t("label_reports_genderGap_recommendations") }}</h2>
            <!--<h2>{{ $t('label_indicator_pillar_'+pillar+'_name')}}</h2>-->
          </div>
          <div class="bottom">
            <b-img
              v-if="lang != 'labels'"
              center
              :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
              height="150"
            />
          </div>
        </div>
        <div class="content">
          <b-card style="width: 100%">
            <h4
              style="margin-top: 30px; margin-bottom: 50px; margin-left: 20px"
            >
              {{ $t("label_reports_genderGap_recommendations") }}
            </h4>
            <div style="padding: 20px">
              <div style="white-space: pre-wrap">
                {{ commentPage }}
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </template>
    <template v-for="(pillar, pindex) in pillarsIds">
      <template v-if="comment[pillar]">
        <div
          v-for="(commentPage, indexPage) in comment[pillar]"
          :id="'pdf-page-comments' + (200 + pindex)"
          :key="indexPage"
          class="pdf-page pdf-page-flex pillar-page"
        >
          <!--<div class="page-number">{{ pages[index + '0'] }}</div>-->
          <div class="sidebar" :class="pindex % 2 == 1 ? 'second-color' : ''">
            <div class="top">
              <b-img
                v-if="lang != 'labels'"
                center
                :src="'../static/images/GES_Logo-White' + '.svg'"
                height="100"
              />
              <h3>{{ $t("label_reports_genderGap_title") }}</h3>
            </div>
            <div class="middle">
              <b-img
                center
                :src="'/static/icons/Home/' + pillar + '_icon.svg'"
                width="100"
              />
              <h2>{{ $t("label_reports_genderGap_recommendations") }}</h2>
              <h2>{{ $t("label_indicator_pillar_" + pillar + "_name") }}</h2>
            </div>
            <div class="bottom">
              <b-img
                v-if="lang != 'labels'"
                center
                :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
                height="150"
              />
            </div>
          </div>
          <div class="content">
            <b-card style="width: 100%">
              <h4
                style="margin-top: 30px; margin-bottom: 50px; margin-left: 20px"
              >
                {{ $t("label_reports_genderGap_recommendations") }} ({{
                  $t("label_indicator_pillar_" + pillar + "_acronym")
                }})
              </h4>
              <div style="padding: 5px 20px">
                <div style="white-space: pre-wrap">
                  {{ commentPage }}
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </template>
    </template>

    <div
      :id="'pdf-page-conventions'"
      class="pdf-page pdf-page-flex pillar-page"
    >
      <div class="page-number">
        {{ pages["conventions"] }}
      </div>
      <div class="sidebar">
        <div class="top">
          <b-img
            v-if="lang != 'labels'"
            center
            :src="'../static/images/GES_Logo-White' + '.svg'"
            height="100"
          />
          <h3>{{ $t("label_reports_genderGap_title") }}</h3>
        </div>
        <div class="middle">
          <h2>
            {{ $t("label_reports_genderGap_indicatorsList_lettlerhead_title") }}
          </h2>
        </div>
        <div class="bottom">
          <b-img
            v-if="lang != 'labels'"
            center
            :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
            height="150"
          />
        </div>
      </div>
      <div v-if="pillarsData" class="content">
        <b-row>
          <b-col md="4">
            <table
              v-for="(pillar, index) in ['OP', 'PP']"
              :key="index"
              class="indicators-list"
            >
              <tr>
                <th>
                  {{ $t("label_indicator_pillar_" + pillar + "_acronym") }}
                  {{ $t("label_indicator_pillar_" + pillar + "_name") }}
                </th>
              </tr>
              <tr
                v-for="(indicator, indexIndicator) in indicatorsDataByPillarId(
                  pillar
                )"
                :key="indexIndicator"
              >
                <td>{{ $t(indicator.acronym) }} {{ $t(indicator.name) }}</td>
              </tr>
            </table>
          </b-col>
          <b-col md="4">
            <table
              v-for="(pillar, index) in ['RSH', 'R']"
              :key="index"
              class="indicators-list"
            >
              <tr>
                <th>
                  {{ $t("label_indicator_pillar_" + pillar + "_acronym") }}
                  {{ $t("label_indicator_pillar_" + pillar + "_name") }}
                </th>
              </tr>
              <template
                v-for="(indicator, indicatorIndex) in indicatorsDataByPillarId(
                  pillar
                )"
              >
                <tr v-if="indicator.id !== 'R6'" :key="indicatorIndex">
                  <td>{{ $t(indicator.acronym) }} {{ $t(indicator.name) }}</td>
                </tr>
              </template>
            </table>
          </b-col>
          <b-col md="4">
            <table
              v-for="(pillar, index) in ['R']"
              :key="index"
              class="indicators-list"
              style="margin-top: 5px"
            >
              <template
                v-for="(indicator, indexIndicator) in indicatorsDataByPillarId(
                  pillar
                )"
              >
                <tr v-if="indexIndicator > 4" :key="indexIndicator">
                  <td>{{ $t(indicator.acronym) }} {{ $t(indicator.name) }}</td>
                </tr>
              </template>
            </table>
            <table
              v-for="(pillar, index) in ['PDP']"
              :key="index"
              class="indicators-list"
            >
              <tr>
                <th>
                  {{ $t("label_indicator_pillar_" + pillar + "_acronym") }}
                  {{ $t("label_indicator_pillar_" + pillar + "_name") }}
                </th>
              </tr>
              <tr
                v-for="(indicator, indexIndicator) in indicatorsDataByPillarId(
                  pillar
                )"
                :key="indexIndicator"
              >
                <td>{{ $t(indicator.acronym) }} {{ $t(indicator.name) }}</td>
              </tr>
            </table>
          </b-col>
        </b-row>
      </div>
    </div>

    <div
      :id="'pdf-page-conventions2'"
      class="pdf-page pdf-page-flex pillar-page"
    >
      <div class="page-number">
        {{ pages["conventions"] }}
      </div>
      <div class="sidebar">
        <div class="top">
          <b-img
            v-if="lang != 'labels'"
            center
            :src="'../static/images/GES_Logo-White' + '.svg'"
            height="100"
          />
          <h3>{{ $t("label_reports_genderGap_title") }}</h3>
        </div>
        <div class="middle">
          <h2>
            {{ $t("label_reports_genderGap_indicatorsList_lettlerhead_title") }}
          </h2>
        </div>
        <div class="bottom">
          <b-img
            v-if="lang != 'labels'"
            center
            :src="'/static/images/unpd/unpd_logo_white_' + lang + '.svg'"
            height="150"
          />
        </div>
      </div>
      <div v-if="pillarsData" class="content">
        <b-row>
          <b-col md="4">
            <table
              v-for="(pillar, index) in ['PH']"
              :key="index"
              class="indicators-list"
            >
              <tr>
                <th>
                  {{ $t("label_indicator_pillar_" + pillar + "_acronym") }}
                  {{ $t("label_indicator_pillar_" + pillar + "_name") }}
                </th>
              </tr>
              <tr
                v-for="(indicator, indicatorIndex) in indicatorsDataByPillarId(
                  pillar
                )"
                :key="indicatorIndex"
              >
                <td>{{ $t(indicator.acronym) }} {{ $t(indicator.name) }}</td>
              </tr>
            </table>
          </b-col>
          <b-col md="4">
            <table
              v-for="(pillar, index) in ['WLBS']"
              :key="index"
              class="indicators-list"
            >
              <tr>
                <th>
                  {{ $t("label_indicator_pillar_" + pillar + "_acronym") }}
                  {{ $t("label_indicator_pillar_" + pillar + "_name") }}
                </th>
              </tr>
              <tr
                v-for="(indicator, indicatorIndex) in indicatorsDataByPillarId(
                  pillar
                )"
                :key="indicatorIndex"
              >
                <td>{{ $t(indicator.acronym) }} {{ $t(indicator.name) }}</td>
              </tr>
            </table>
          </b-col>
          <b-col md="4">
            <table
              v-for="(pillar, index) in ['COM']"
              :key="index"
              class="indicators-list"
            >
              <tr>
                <th>
                  {{ $t("label_indicator_pillar_" + pillar + "_acronym") }}
                  {{ $t("label_indicator_pillar_" + pillar + "_name") }}
                </th>
              </tr>
              <tr
                v-for="(indicator, indexIndicator) in indicatorsDataByPillarId(
                  pillar
                )"
                :key="indexIndicator"
              >
                <td>{{ $t(indicator.acronym) }} {{ $t(indicator.name) }}</td>
              </tr>
            </table>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { axiosCall } from "../utils/axiosCall";

export const FULL_PAGE_CHART = [
  {
    numberOfCharts: 1,
    firstChart: 0,
  },
];
export const DEFAULT_TWO_PAGE_CHARTS = [
  {
    numberOfCharts: 1,
    firstChart: 0,
  },
  {
    numberOfCharts: 1,
    firstChart: 1,
  },
];
export default {
  name: "ReportsGenderGapPdf",
  data: function () {
    return {
      overflowFinished: false,
      comment: {},
      indicatorsHasComments: {},

      pages: {},
      today: "",
      rendered: 0,
      dataReady: false,
      pillarsData: false,
      dataPreReady: false,
      indicatorSummarySections: {
        PP: {
          indicatorPages: 2,
          pages: [
            {
              lastIndicator: 6,
              firstIndicator: 0,
            },
            {
              lastIndicator: 10,
              firstIndicator: 6,
            },
          ],
        },
        PDP: {
          indicatorPages: 2,
          pages: [
            {
              lastIndicator: 6,
              firstIndicator: 0,
            },
            {
              lastIndicator: 10,
              firstIndicator: 6,
            },
          ],
        },
        WLBS: {
          indicatorPages: 2,
          pages: [
            {
              lastIndicator: 6,
              firstIndicator: 0,
            },
            {
              lastIndicator: 10,
              firstIndicator: 6,
            },
          ],
        },
      },
      multipleGraphSections: {
        OP2: {
          pages: DEFAULT_TWO_PAGE_CHARTS,
        },
        OP3: {
          pages: [
            {
              numberOfCharts: 1,
              firstChart: 0,
            },
            {
              numberOfCharts: 1,
              firstChart: 1,
            },
            {
              numberOfCharts: 1,
              firstChart: 2,
            },
          ],
        },
        PP1: {
          pages: DEFAULT_TWO_PAGE_CHARTS,
        },
        PP2: {
          pages: FULL_PAGE_CHART,
        },
        PP3: {
          pages: DEFAULT_TWO_PAGE_CHARTS,
        },
        PP6: {
          pages: DEFAULT_TWO_PAGE_CHARTS,
        },
        PP7: {
          pages: DEFAULT_TWO_PAGE_CHARTS,
        },
        PP9: {
          pages: DEFAULT_TWO_PAGE_CHARTS,
        },
        RSH3: {
          pages: FULL_PAGE_CHART,
        },
        RSH4: {
          pages: FULL_PAGE_CHART,
        },
        RSH5: {
          pages: FULL_PAGE_CHART,
        },
        PDP3: {
          pages: FULL_PAGE_CHART,
        },
        PDP6: {
          pages: DEFAULT_TWO_PAGE_CHARTS,
        },
        PDP7: {
          pages: FULL_PAGE_CHART,
        },
        R4: {
          pages: FULL_PAGE_CHART,
        },
        PH2: {
          pages: FULL_PAGE_CHART,
        },
        PH3: {
          pages: FULL_PAGE_CHART,
        },
        PH4: {
          pages: FULL_PAGE_CHART,
        },
        PH5: {
          pages: FULL_PAGE_CHART,
        },
        PH6: {
          pages: FULL_PAGE_CHART,
        },
        WLBS2: {
          pages: DEFAULT_TWO_PAGE_CHARTS,
        },
      },
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters([
      "pillarsIds",
      "getBusiness",
      "indicatorsDataByPillarId",
      "getIndicatorData",
      "getCurrentSnapshot",
    ]),
  },
  created: async function () {
    if (this.$route.params.lang) {
      await this.$store.dispatch("setLangNew", this.$route.params.lang);
    }
  },
  async mounted() {
    var auth = {
      data: {
        id: this.$route.params.token,
      },
    };
    var business = {
      id: this.$route.params.business,
    };
    var snapshot = {
      snapshotId: this.$route.params.snapshot,
    };

    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; // January is 0!

    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    this.today = yyyy + "-" + mm + "-" + dd;

    await this.$store.commit("authSuccess", auth);
    await this.$store.commit("setBusiness", business);
    await this.$store.commit("setCurrentBusiness", business);
    await this.$store.commit(
      "setAccountRole",
      this.$route.params.accountroleid
    );
    await this.$store
      .dispatch("BUSINESS_GET")
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
    await this.$store.commit("setSnapshots", [snapshot]);
    await this.$store
      .dispatch("PILLARS_GET")
      .then(() => {
        this.createPagination();
      })
      .catch((err) => {
        console.log(err);
      });
    await this.getIndicatorsComments();
    this.dataPreReady = true;
    setTimeout(() => {
      this.dataReady = true;
    }, 6000);
  },
  /* updated () {
    console.log('update')
    if (!this.overflowFinished) {
      this.checkOverflow()
    }
  },*/
  methods: {
    getIndicatorsComments: async function () {
      const where = {};

      where["where"] = {};
      where["where"]["snapshotId"] = this.getCurrentSnapshot.snapshotId;
      await axiosCall({
        url: "GenderGapReportComments?filter=" + JSON.stringify(where),
        method: "GET",
      }).then((response) => {
        response.data.map((comment) => {
          if (comment.indicator_acronym) {
            const pillarFromIndicator = comment.indicator_acronym.replace(
              /[0-9]/g,
              ""
            );
            if (
              typeof this.comment[
                `${pillarFromIndicator}_indicators_comment_all`
              ] === "undefined"
            ) {
              this.comment[`${pillarFromIndicator}_indicators_comment_all`] =
                [];
              this.comment[`${pillarFromIndicator}_indicators_comment_all`][0] =
                "";
            }
            this.comment[
              `${pillarFromIndicator}_indicators_comment_all`
            ][0] += `(${this.$t(comment.indicator_acronym)}) ${
              comment.comment
            } \n\n`;
          }
          if (comment.pillar_acronym_id) {
            if (
              typeof this.comment[comment.pillar_acronym_id] === "undefined"
            ) {
              this.comment[comment.pillar_acronym_id] = [];
              this.comment[comment.pillar_acronym_id][0] = "";
            }
            this.comment[comment.pillar_acronym_id][0] += `${this.$t(
              comment.indicator_acronym
            )} ${comment.comment} \n\n`;
          }
          if (comment.general) {
            if (typeof this.comment["general"] === "undefined") {
              this.comment["general"] = [];
              this.comment["general"][0] = "";
            }
            this.comment["general"][0] += `${this.$t(
              comment.indicator_acronym
            )} ${comment.comment} \n\n `;
          }
        });
        Object.keys(this.comment).map((key) => {
          this.comment[key] = this.splitArray(this.comment[key][0].split(" "));
        });
        this.pillarsIds.map((pillar) => {
          const keys = Object.keys(this.comment);
          const pillarArr = keys.filter((comm) => comm.includes(pillar));
          const removePillar = pillarArr.map((comm) =>
            comm.replace(pillar, "")
          );
          const hasComments = removePillar.filter((comm) => comm.length > 0);
          this.indicatorsHasComments[pillar] = hasComments.length > 0;
        });
      });
    },
    /*    isOverflowing (el) {
      var curOverf = el.style.overflow
      if (!curOverf || curOverf === 'visible') {
        el.style.overflow = 'hidden'
      }

      var isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight

      el.style.overflow = curOverf
      return isOverflowing
    },*/
    splitArray(inputArray) {
      const perChunk = 300; // items per chunk

      const result = inputArray.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
      }, []);
      return result.map((arr) => arr.join(" "));
    },
    /*    checkOverflow () {
      const element = document.getElementById('pdf-general-comments-0')
      if (element) {
        const isOverflowing = this.isOverflowing(element)
        console.log(isOverflowing)
        const text = this.comment['general'][0]
        var lastIndex = text.lastIndexOf(' ')
        const newText = text.substring(0, lastIndex)
        // const word = text.substring(lastIndex)
        this.comment['general'][0] = newText
        console.log(this.comment['general'][0].length)
        if (this.comment['general'].length < 1) {
          // this.comment['general'].push('')
        }
        // this.comment['general'][1] = this.comment['general'][1] + ' ' + word

        if (!isOverflowing) {
          this.overflowFinished = true
        }
        this.$forceUpdate()
      }
    },*/
    getIndicatorPagingInfo(pillar, indexIndicatorChart) {
      if (
        this.multipleGraphSections[pillar + indexIndicatorChart] &&
        this.multipleGraphSections[pillar + indexIndicatorChart].pages
      ) {
        return this.multipleGraphSections[pillar + indexIndicatorChart].pages;
      }
      return null;
    },
    getMultipleGraphsPage(index, indexIndicatorSummary, graphIndex) {
      let pagesHash = null;

      let tempIndexIndicatorSummary = JSON.parse(
        JSON.stringify(indexIndicatorSummary)
      );
      tempIndexIndicatorSummary++;

      let tempGraphIndex = JSON.parse(JSON.stringify(graphIndex));
      tempGraphIndex++;

      pagesHash =
        index +
        "" +
        tempIndexIndicatorSummary +
        tempGraphIndex +
        "indicatorGraph";
      return this.pages[pagesHash];
    },
    getPartialPillarSummaryPage(index, indexIndicatorSummary) {
      let tempIndexIndicatorSummary = JSON.parse(
        JSON.stringify(indexIndicatorSummary)
      );
      tempIndexIndicatorSummary++;
      const pagesHash = index + "" + tempIndexIndicatorSummary + "gauge";
      return this.pages[pagesHash];
    },
    indicatorPerPillar(pillarId) {
      return this.indicatorsDataByPillarId(pillarId).length;
    },
    createPagination() {
      const pages = {
        "0cover": 1,
        "0treemap": 2,
      };
      let currentPage = 2;
      for (const i in this.pillarsIds) {
        currentPage++;
        pages[i + "0"] = currentPage;
        if (this.multipleIndicatorsPage(this.pillarsIds[i])) {
          for (
            let index = 1;
            index <=
            this.indicatorSummarySections[this.pillarsIds[i]].indicatorPages;
            index++
          ) {
            currentPage++;
            pages[i + index + "gauge"] = currentPage;
          }
        } else {
          currentPage++;
          pages[i + 1 + "" + "gauge"] = currentPage;
        }
        for (
          let j = 1;
          j <= this.indicatorsDataByPillarId(this.pillarsIds[i]).length;
          j++
        ) {
          currentPage++;
          pages[i + j] = currentPage;
          if (this.hasMoreThanOneChart(this.pillarsIds[i], j)) {
            for (
              let k = 1;
              k <= this.getCharts(this.pillarsIds[i], j).length;
              k++
            ) {
              currentPage++;
              pages[i + j + k + "indicatorGraph"] = currentPage;
            }
          } else {
            if (this.isFullPageIndicatorGraph(this.pillarsIds[i], j)) {
              currentPage++;
              pages[i + j + "1" + "indicatorGraph"] = currentPage;
            }
          }
        }
      }
      pages["conventions"] = currentPage + 1;
      this.pillarsData = true;
      this.pages = pages;
    },
    getIndicator(pillar, indicatorLabel) {
      const indicatorIndex = pillar + indicatorLabel;
      return this.$store.getters.getIndicatorData(pillar, indicatorIndex);
    },
    hasMoreThanOneChart(pillar, indicator) {
      const tempIndicator = this.getIndicator(pillar, indicator);

      if (
        tempIndicator &&
        tempIndicator.chart &&
        tempIndicator.chart.length > 1
      ) {
        return true;
      }
      return false;
    },
    getCharts(pillar, indicator) {
      const tempIndicator = this.getIndicator(pillar, indicator);

      if (tempIndicator && tempIndicator.chart) {
        return tempIndicator.chart;
      }
      return false;
    },
    isFullPageIndicatorGraph(pillar, indicator) {
      const pagingInformation = this.multipleGraphSections[pillar + indicator];
      if (pagingInformation && pagingInformation.pages === FULL_PAGE_CHART) {
        return true;
      }

      return false;
    },
    getIndicatorChartData(pillar, indicator) {
      const tempIndicator = this.getIndicator(pillar, indicator);

      if (tempIndicator && tempIndicator.chart) {
        return tempIndicator.chart;
      }

      return null;
    },
    getChartDataByIndex(indicatorChartData, index) {
      if (indicatorChartData[index]) {
        return indicatorChartData[index];
      }

      return {};
    },
    getChartDataType(indicatorChartData) {
      if (indicatorChartData["type"]) {
        return indicatorChartData["type"];
      }
      return null;
    },

    multipleIndicatorsPage(pillarId) {
      if (
        pillarId &&
        this.indicatorSummarySections[pillarId] &&
        this.indicatorSummarySections[pillarId].pages
      ) {
        if (this.indicatorSummarySections[pillarId].pages.length > 1) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>

@import "../assets/css/variables.scss";

.pdf-container {
  .indicator-page .indicator-label {
    width: 88px;
    height: 88px;
    color: #fff;
    border-radius: 100%;
    border: 6px solid #fff;
    margin: 0 auto;
    font-size: 28px;
    font-family: $font-subtitle;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      margin: 0;
    }
  }
  .content-sumary {
    padding: 10px;
    width: 975px;
    .conventions {
      display: flex;
    }
    .general-index-container {
      width: 75%;
      margin-right: 10px;
    }
    .conventions-container {
      width: 25%;
    }
    .chart {
      .card {
        margin-top: 5px;
      }
    }
  }
  .conventions-disclaimer {
    font-family: $font-subtitle;
    font-size: 1rem;
  }
}
.indicators-list {
  font-family: $font-text;
  font-size: 0.79rem;
  margin-top: 5px;
  text-align: justify;
  width: 100% !important;
  th {
    text-transform: uppercase;
    background-color: #414141;
    color: #fff;
    font-family: $font-subtitle;
    width: 100% !important;
  }
  tr {
    border: 1px solid #414141;
  }
}
.content-card, .content-card-double{
  scale: 0.95;
}
h4{
  text-align: center;
}

</style>
<style lang="scss">

.pdf-container {
  .table th, .table td {
    padding: 0.5rem;
  }

#pdf-page-73 {
  .bullet-container {
    margin-bottom: 8px;
  }
}
  #pdf-page-76 {
    .card-employment-policies .table .question {
      line-height: 1.16rem;
    }
  }
}
</style>
